import type accountId from "./id";

const accountEn: typeof accountId = {
	account: {
		title: "Account",
		subtitle: "Manage package, partner info, bank account and settings",
		loading: "Loading…",
		tabs: {
			billing: "Billing",
			partner: "Partner Info",
			bank: "Bank Account",
			setting: "Settings",
		},
		partner: {
			title: "Partner Info",
			name: "Business Name",
			company: "Company Name",
			address: "Address",
			phone: "Phone Number",
			email: "Email",
			pic: "PIC",
			pic_phone: "PIC Phone Number",
			commission: "Commission (%)",
			referral_title: "Your Referral Code",
			referral_description:
				"Share this code with other partners. You earn a commission of",
		},
		bank: {
			title: "Bank Account",
			subtitle:
				"The bank account used to withdraw your partner Cazhbox balance",
			notice:
				"Note: to change your bank account details, please contact Admin via the Help menu.",
			bank: "Bank",
			holder: "Account Holder",
			number: "Account Number",
		},
		billing: {
			title: "Active Package",
			current_package: "Package",
			expired_at: "Expires on",
			days_left: "Days left",
			last_payment: "Last payment",
			expired_badge: "Expired",
			active_badge: "Active",
			extend_title: "Extend Package",
			extend_description: "Extend the currently active package.",
			change_title: "Change Package",
			change_description: "Move to another package from the next period.",
			qty: "Number of packages",
			choose_package: "Choose package",
			total: "Total",
			extend_action: "Extend",
			change_action: "Change Package",
			extend_success: "Package extended",
			change_success: "Package changed",
			confirm_extend:
				"Extend this package? An invoice will be issued for the selected quantity.",
			confirm_change:
				"Change package? An invoice will be issued for the selected package and quantity.",
			no_packages: "No packages available yet.",
			days_unit: "days",
		},
		setting: {
			title: "Currency",
			description: "The currency used to display all amounts.",
			search_placeholder: "Search country or currency",
			current: "Active currency",
			save: "Save",
			success: "Currency updated",
			empty: "No currency found.",
		},
	},
};

export default accountEn;
